import { RG_TYPE as o } from "@project-rouge/rg-core";
function a(e) {
  return Array.from(
    new Set(
      Object.keys(e).filter((r) => e[r]).map((r) => i[r]).flat()
    )
  );
}
const i = {
  Unit: [o.Module],
  Cores: [o.Core],
  Corridors: [o.Corridor],
  Services: [o.Module],
  Amenities: [o.Module],
  Entrances: [o.Entrance],
  Facade: [o.Facade],
  Roof: [o.Roof],
  Parapets: [o.Parapet],
  Floors: [o.Floor],
  Ceilings: [o.Ceiling],
  Walls: [o.Wall],
  Windows: [o.Window, o.Glazing],
  Doors: [o.Door],
  Structure: [o.Beam, o.Column],
  Commercials: [o.EmptySpace]
};
export {
  a as getFeVisibility
};
//# sourceMappingURL=index2.js.map
